/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LaunchStatus = {
    Provisional: 'Provisional',
    Novelty: 'Novelty',
    CarryOver: 'CarryOver',
    Outgoing: 'Outgoing'
} as const;
export type LaunchStatus = typeof LaunchStatus[keyof typeof LaunchStatus];


export function instanceOfLaunchStatus(value: any): boolean {
    for (const key in LaunchStatus) {
        if (Object.prototype.hasOwnProperty.call(LaunchStatus, key)) {
            if (LaunchStatus[key as keyof typeof LaunchStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LaunchStatusFromJSON(json: any): LaunchStatus {
    return LaunchStatusFromJSONTyped(json, false);
}

export function LaunchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaunchStatus {
    return json as LaunchStatus;
}

export function LaunchStatusToJSON(value?: LaunchStatus | null): any {
    return value as any;
}

export function LaunchStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LaunchStatus {
    return value as LaunchStatus;
}

